import React, { useState } from 'react'
import { setCookie } from '../utils/api/cookies'
import { useNavigate } from 'react-router-dom'
import * as api from '../utils/api/apiClient'
import { useAuth } from '../context/AuthContext'
import { toast } from 'react-toastify'

const Login = () => {
  const { isLogin, setIsLogin } = useAuth()
  const navigate = useNavigate()
  const [state, setState] = useState({
    email: '',
    password: '',
  })
  const [errors, setErrors] = useState({})

  const validateForm = () => {
    const errors = {}
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
    if (!state.email) {
      errors.email = 'Email is required'
    } else if (!emailPattern.test(state.email)) {
      errors.email = 'Invalid email format'
    }
    if (!state.password) {
      errors.password = 'Password is required'
    } else if (state.password.length < 4) {
      errors.password = 'Password must be at least 6 characters long'
    }
    return errors
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    const validationErrors = validateForm()
    setErrors(validationErrors)
    if (Object.keys(validationErrors).length > 0) return

    try {
      const res = await api.login({
        email: state.email,
        password: state.password,
      })
      const TokenExpiresAt = Date.parse(res.data.token_expires_at)
      const currentMilies = Date.now()

      const token = res.data.token
      setCookie(
        'token',
        token,
        parseInt((TokenExpiresAt - currentMilies) / 1000)
      )
      setIsLogin(true)
      toast.success('Login Success')
      navigate('/')
    } catch (error) {
      console.log(error)
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message)
      }
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setState((prevState) => ({ ...prevState, [name]: value }))
    setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }))
  }

  return (
    <div className='mt-10'>
      <div className='flex bg-white rounded-lg shadow-lg overflow-hidden mx-auto max-w-sm lg:max-w-4xl'>
        <img
          src={
            'https://img.freepik.com/free-vector/login-concept-illustration_114360-739.jpg'
          }
          width={500}
          height={400}
          className='hidden lg:block'
          alt='Picture of the author'
        />
        <div className='w-full p-8 lg:w-1/2'>
          <h2 className='text-2xl font-semibold text-black text-center'>
            Inflection
          </h2>
          <p className='text-xl text-black text-center'>Welcome back!</p>

          <div className='mt-4 flex items-center justify-between'>
            <span className='border-b w-1/5 lg:w-1/4'></span>
            <a href='#' className='text-xs text-center text-black uppercase'>
              or login with email
            </a>
            <span className='border-b w-1/5 lg:w-1/4'></span>
          </div>
          <form onSubmit={handleSubmit}>
            <div className='mt-4'>
              <label className='block text-black text-sm font-bold mb-2'>
                Email Address
              </label>
              <input
                className='bg-light_gray text-black focus:outline-none focus:shadow-outline border border-gray-300 rounded py-2 px-4 block w-full appearance-none'
                type='email'
                value={state.email}
                name='email'
                // onChange={(e) => setState({ ...state, email: e.target.value })}
                onChange={handleChange}
              />
              {errors.email && (
                <p className='text-error text-xs italic'>{errors.email}</p>
              )}
            </div>
            <div className='mt-4'>
              <div className='flex justify-between'>
                <label className='block text-black text-sm font-bold mb-2'>
                  Password
                </label>
                <a
                  to='#'
                  className='text-xs hover:text-black hover:underline text-black'
                >
                  Forget Password?
                </a>
              </div>
              <input
                className='bg-light_gray text-gray focus:outline-none focus:shadow-outline border border-gray rounded py-2 px-4 block w-full appearance-none'
                type='password'
                name='password'
                value={state.password}
                // onChange={(e) =>
                //   setState({ ...state, password: e.target.value })
                // }
                onChange={handleChange}
              />
              {errors.password && (
                <p className='text-error text-xs italic'>{errors.password}</p>
              )}
            </div>
            <div className='mt-8'>
              <button
                type='submit'
                className='bg-tan text-black font-bold py-2 px-4 w-full rounded hover:bg-beige duration-300'
              >
                Login
              </button>
            </div>
          </form>
          {/* <div className='mt-4 flex items-center justify-between'>
            <span className='border-b w-1/5 md:w-1/4'></span>
            <a
              href='/sign_up'
              className='text-xs text-olive hover:underline hover:text-black uppercase'
            >
              or sign up
            </a>
            <span className='border-b w-1/5 md:w-1/4'></span>
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default Login
